<template>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <h5>Lista Notifica</h5>
              <div style="display: flex;">
              </div>
              <!-- <button type="button" id="add-btn" class="btn btn-primary" @click="this.$router.push({ name: 'HorseAdd', params: {  } });">+ Nuovo</button> -->
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-3" id="table" :class="{ tloading: loading }">
                <custom-table ref="table$" :rows="data" @action="runAction"
                              :columns="[
                                  {
                                      title: 'message',
                                      type: 'text',
                                      data: 'name',
                                  },
                                  {
                                      title: 'created',
                                      type: 'date',
                                      data: 'created',
                                  },
                              ]"
                              :actions="[
                                  {
                                      title: 'Visualizza Cavallo',
                                      tooltip: 'view',
                                      key: 'view',
                                  },
                              ]"
                              :pagination="pagination"
                              @page-changed="handlePageChange"
                              @update-pagination="handlePaginationUpdate"
                              @search-changed="handleSearchChange"
                />
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>


<script>

import {userService} from "@/services/UsersService";
import CustomTable from "@/components/CustomTable.vue";
import {useTableData} from "@/composables/useTableData";
import setNavPills from "@/assets/js/nav-pills.js";


export default {
  name: "Notifications",
  data() {
    return {
      notifications: [],
    };
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', []);
  },
  setup(){
    return useTableData(
        userService.getNotifications.bind(userService),
        15
    );
  },
  components: {
    CustomTable,
  },
  mounted() {
    this.fetchData({});
    setNavPills();
  },
  methods: {
    async runAction({action, row}){
      if(action.key == 'view'){
        if(row.horse_id) this.$router.push({ name: 'Horse', params: { id: row.horse_id, action: 'view' } });
      }
    },
  }
};
</script>
